export const LABEL =
    "font-normal text-[13px] text-sm md:text-base text-LIGHT_BLACK pb-1";
